<div class="gw-mt-6 gw-border-base md:gw-rounded-2xl">
  <div
    class="gw-border-content-header gw-border-0 gw-border-b gw-border-b-[1px] gw-border-b-border-normal gw-border-solid gw-bg-background-neutral-1 gw-h-[56px] gw-flex gw-justify-between gw-items-center gw-px-4 md:gw-px-6"
  >
    <p class="gw-text-[16px] title gw-font-bold gw-text-text-primary">
      Juros e multa
    </p>
    <gatewee-button
      *ngIf="formArray.length === 0"
      title="ADICIONAR"
      variant="secondary"
      iconName="@tui.plus"
      class="gw-w-full gw-max-w-[120px] md:gw-max-w-[124px]"
      (clicked)="addInterestForm()"
    ></gatewee-button>
    <gatewee-button
      *ngIf="formArray.length === 1"
      title="REMOVER"
      variant="secondary"
      iconName="@tui.trash"
      class="gw-w-full gw-max-w-[120px] md:gw-max-w-[124px]"
      (clicked)="removeSingle()"
    ></gatewee-button>
  </div>

  <div
    *ngIf="formArray.length === 0"
    class="gw-flex gw-flex-col md:gw-flex-row gw-gap-[16px] gw-border-base gw-items-center gw-bg-background-neutral-1 gw-m-medium md:gw-m-large gw-px-[16px] gw-py-[16px] gw-rounded-2xl"
  >
    <gatewee-icon
      icon="@tui.info"
      iconStyle="outline"
      size="24px"
    ></gatewee-icon>
    <div class="gw-col">
      <p class="gw-text-text-secondary gw-text-[16px] gw-font-bold">
        Nenhum juros/multa foi adicionado.
      </p>
      <p class="gw-text-text-secondary">
        Para inserir um juros/multa clique em "adicionar+"
      </p>
    </div>
  </div>

  <div
    *ngFor="let form of formArray.controls; let i = index"
    class="gw-border-base gw-bg-background-neutral-1 gw-m-[16px] md:gw-m-x-large gw-m-medium gw-px-[16px] gw-py-[16px] gw-rounded-2xl"
  >
    <ng-container *ngIf="!saved[i]; else savedView">
      <form [formGroup]="form" class="gw-rounded-2xl">
        <div
          class="gw-flex gw-flex-col md:gw-flex-row gw-gap-[8px] md:gw-gap-[24px] gw-items-center md:gw-justify-between"
        >
          <div
            class="gw-flex gw-w-full gw-flex-col md:gw-flex-row gw-gap-x-large"
          >
            <div class="gw-w-full">
              <gatewee-input-v2
                [form]="form"
                label="Valor ao Mês"
                controlName="interestMonthlyPercent"
                [format]="'percent'"
                type="text"
                placeholder="Ex: 1%"
                [iconName]="'@tui.circle-percent'"
                [customMessages]="{
                  notMoreThan100: 'O valor não pode ser maior que 100%'
                }"
              ></gatewee-input-v2>
            </div>
            <div class="gw-w-full">
              <gatewee-input-v2
                [form]="form"
                label="Valor"
                controlName="finePercent"
                [format]="'percent'"
                type="text"
                placeholder="Ex: 1%"
                [iconName]="'@tui.circle-percent'"
                [customMessages]="{
                  notMoreThan100: 'O valor não pode ser maior que 100%'
                }"
              ></gatewee-input-v2>
            </div>
          </div>
          <gatewee-button
            title="SALVAR"
            variant="primary"
            class="gw-w-full md:gw-max-w-[80px] gw-text-[14px] gw-mt-[13px]"
            [disabled]="form.invalid"
            (clicked)="saveSingle(i)"
          ></gatewee-button>
        </div>
      </form>
    </ng-container>

    <ng-template #savedView>
      <div
        class="gw-flex gw-flex-col md:gw-flex-row gw-items-center gw-justify-between"
      >
        <div
          class="gw-w-full gw-flex gw-flex-col md:gw-flex-row gw-self-start md:gw-self-unset gw-items-start md:gw-items-center gw-gap-4"
        >
          <span class="gw-hidden md:gw-block">
            <gatewee-icon
              icon="@tui.trash"
              iconStyle="primary"
              size="20px"
              class="border-icon gw-border-icon-primary gw-rounded-lg gw-p-2 gw-cursor-pointer"
              (click)="removeSingle()"
            ></gatewee-icon>
          </span>
          <div
            class="gw-flex gw-flex-col md:gw-flex-row md:gw-items-baseline md:gw-gap-[48px] gw-gap-[24px]"
          >
            <div class="gw-full gw-max-[171px]">
              <p class="gw-font-bold gw-text-text-primary">Valor ao Mês</p>
              <p class="gw-text-text-secondary">
                {{
                  formSaved[i].interestMonthlyPercent
                    ? formSaved[i].interestMonthlyPercent + '%'
                    : 'Não informado'
                }}
              </p>
            </div>

            <div class="gw-full gw-max-[171px]">
              <p class="gw-font-bold gw-text-text-primary">Valor</p>
              <p class="gw-text-text-secondary">
                {{
                  formSaved[i].interestMonthlyPercent
                    ? formSaved[i].finePercent + '%'
                    : 'Não informado'
                }}
              </p>
            </div>
          </div>
        </div>

        <div
          class="gw-flex gw-w-full gw-flex-col md:gw-flex-row gw-gap-medium gw-mt-medium md:gw-mt-0 md:gw-justify-end"
        >
          <gatewee-button
            title="EDITAR"
            variant="outline"
            class="gw-w-full md:gw-w-[104px] gw-text-[14px]"
            (clicked)="edit(i)"
            [iconName]="'@tui.pencil'"
          ></gatewee-button>
          <gatewee-button
            title="REMOVER"
            variant="primary"
            class="gw-flex gw-w-full gw-text-[14px] gw-text-brand-primary md:gw-mt-0 md:gw-hidden md:gw-w-[104px]"
            (clicked)="removeSingle()"
            iconName="@tui.trash"
          ></gatewee-button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
